import { useEffect } from "react";

function useScrollToTop() {
  useEffect(() => {
    const timer = window.setTimeout(() => {
      const main = document.querySelector("main");
      if (main) {
        main.scrollTop = 0;
      }
      window.scrollTo(0, 0);
    }, 0);

    return () => window.clearTimeout(timer);
  }, []);
}

export default useScrollToTop;
